<div padding-left padding-right class="help-popover">
    <p [innerHtml]="helpText"></p>
    <p *ngIf="showEmailLink"><a href="mailto:ux@apto.com">Email us your thoughts about this!</a></p>
    <p *ngIf="helpArticleUrl">Want to learn more? <a [href]="helpArticleUrl">View our quick knowledge base article</a></p>
</div>